var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#2D2D3B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7443 4.94388C11.8601 4.75178 12.1386 4.75178 12.2545 4.94388L16.4186 11.8494C16.5041 11.9912 16.4576 12.1755 16.315 12.2597L12.2267 14.6749C12.0865 14.7578 11.9123 14.7578 11.7721 14.6749L7.6837 12.2597C7.54113 12.1755 7.4946 11.9912 7.5801 11.8494L11.7443 4.94388Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2423 19.0744C12.1235 19.2416 11.8752 19.2416 11.7565 19.0744L7.50573 13.0877C7.48711 13.0615 7.51748 13.0285 7.54516 13.0448L11.7722 15.5408C11.9123 15.6235 12.0864 15.6235 12.2265 15.5408L16.4562 13.0448C16.4839 13.0285 16.5143 13.0615 16.4957 13.0877L12.2423 19.0744Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/eth.a85c79200c9f841f0f95826bdb5f9b65.svg";
export { ForwardRef as ReactComponent };